// pages/.../forms/WarehouseForm.tsx
import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import SelectTwo from '../../../../components/SelectTwo';
import { WarehouseDataForm } from '../../../../app/models/Warehouse';

type SelectOpt = { id: number | string; name: string };

type Props = {
  warehouseDataForm: WarehouseDataForm;
  setWarehouseDataForm: (data: WarehouseDataForm) => void;
  centers?: SelectOpt[];
  warehouseTypes?: SelectOpt[];
  disabled?: boolean;
  errorFields?: any;
};

const WarehouseForm = ({
  warehouseDataForm,
  setWarehouseDataForm,
  centers = [],
  warehouseTypes = [],
  disabled = false,
  errorFields
}: Props) => {
  const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

  useEffect(() => {
    setErrors(errorFields);
  }, [errorFields, setErrors]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setWarehouseDataForm({ ...warehouseDataForm, [name]: value });
  };

  const handleChangeNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const num = value === '' ? undefined : Number(value);
    setWarehouseDataForm({ ...warehouseDataForm, [name]: (isNaN(num!) ? 0 : num) as any });
  };

  const handleChangeSelectTwo = (name: keyof WarehouseDataForm, value: number | string | null) => {
    setWarehouseDataForm({ ...warehouseDataForm, [name]: (value ?? null) as any });
  };

  const mapOptions = (opts?: SelectOpt[]) =>
    (opts ?? []).map(o => ({ value: o.id ?? null, label: `${o.name}` }));

  const typeOptions = (opts?: SelectOpt[]) =>
    (opts ?? []).map(o => ({ value: o.id, label: o.name })); // id viene con value del choice

  return (
    <>
      <div className="mb-2 row">

        <div className="col-md-12">
          <label className="col-form-label">Centro <span className="text-danger">*</span></label>
          <SelectTwo
            name="center_id"
            id="center_id"
            inputValue={warehouseDataForm.center_id ?? null}
            options={mapOptions(centers)}
            hasError={fieldHasError('center_id') !== ''}
            onChange={(v: any) => handleChangeSelectTwo('center_id', v?.value ?? null)}
            placeholder="Seleccione un centro"
            onFocus={() => onFocusRemove('center_id')}
            disabled={disabled}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
            {fieldErrorMessage('center_id')}
          </div>
        </div>


        <div className="col-md-12">
          <label className="col-form-label">Tipo de almacén <span className="text-danger">*</span></label>
          <SelectTwo
            name="warehouse_type"
            id="warehouse_type"
            inputValue={warehouseDataForm.warehouse_type ?? null}
            options={typeOptions(warehouseTypes)}
            hasError={fieldHasError('warehouse_type') !== ''}
            onChange={(v: any) => handleChangeSelectTwo('warehouse_type', v?.value ?? null)}
            placeholder="Seleccione tipo"
            onFocus={() => onFocusRemove('warehouse_type')}
            disabled={disabled}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
            {fieldErrorMessage('warehouse_type')}
          </div>
        </div>
        
      </div>

      <div className="mb-2 row">

        <div className="col-md-12">
          <label className="col-form-label">Nombre <span className="text-danger">*</span></label>
          <input
            name="name"
            id="name"
            type="text"
            className={`form-control ${fieldHasError('name')}`}
            value={warehouseDataForm.name ?? ''}
            onChange={handleChange}
            onFocus={() => onFocusRemove('name')}
            placeholder="Ingrese nombre"
            disabled={disabled}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
            {fieldErrorMessage('name')}
          </div>
        </div>

        <div className="col-md-12">
          <label className="col-form-label">Dirección</label>
          <input
            name="address"
            id="address"
            type="text"
            className={`form-control ${fieldHasError('address')}`}
            value={warehouseDataForm.address ?? ''}
            onChange={handleChange}
            onFocus={() => onFocusRemove('address')}
            placeholder="Ingrese dirección"
            disabled={disabled}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
            {fieldErrorMessage('address')}
          </div>
        </div>

      </div>

      <div className="mb-2 row">
        <div className="col-md-12">
          <label className="col-form-label">Capacidad utilizada</label>
          <input
            name="used_capacity"
            id="used_capacity"
            type="number"
            step="0.01"
            className={`form-control ${fieldHasError('used_capacity')}`}
            value={warehouseDataForm.used_capacity ?? 0}
            onChange={handleChangeNumber}
            onFocus={() => onFocusRemove('used_capacity')}
            placeholder="0.00"
            disabled={disabled}
          />
          <div className="invalid-feedback" style={{ display: 'flex' }}>
            {fieldErrorMessage('used_capacity')}
          </div>
        </div>
      </div>
    </>
  );
};

export default WarehouseForm;
